import * as Yup from 'yup'

import { IssueStatus } from './types'

/** Application level issue required fields */
const issueOrgSchema = Yup.object().shape({
  /** The application node ID. */
  appId: Yup.string().uuid().required(),
  /** The organization node ID. */
  organizationId: Yup.string().uuid().required(),
})

/** The field that could be mutated externally. */
export type MutableField =
  | 'title'
  | 'body'
  | 'platform'
  | 'sdkVersion'
  | 'status'
  | 'labels'

/** Fields that could be updated from UI */
export const publicFieldsRules = {
  title: Yup.string().required(),
  platform: Yup.string().required(),
  sdkVersion: Yup.string().required(),
  body: Yup.string().ensure(),
  labels: Yup.array().ensure(),
  status: Yup.string().lowercase().default(IssueStatus.open).required(),
}

/** Global issue could be created for every organization app, therefore specification of the organization and app IDs are not required */
export const globalIssueSchema = Yup.object().shape({
  ...publicFieldsRules,
  /** The user's internal portal ID. */
  authorId: Yup.string().required(),
  //TODO: this should be an ISO date formatted string, check out how to validate this...
  createdAt: Yup.number().required(),
  timeline: Yup.array().ensure(),
  updatedAt: Yup.number(),
  closedAt: Yup.number(),
  id: Yup.string().uuid().required(),
})

/** Compound schema to validate an application issue object */
export const issueSchema = Yup.mixed()
  .concat(globalIssueSchema)
  .concat(issueOrgSchema)

/** Issue comment validation schema */
export const newCommentSchema = Yup.object().shape({
  id: Yup.string().uuid().required(),
  body: Yup.string().trim().required(),
  createdAt: Yup.number().required(),
  /** The user's internal portal ID. */
  authorId: Yup.string().required(),
})
